import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import type { unitMapping } from '#src/lib/style.ts';
import { getTextSize } from '#src/lib/text.ts';

import { HalfCircularProgressBar } from './HalfCircularProgressBar/index.tsx';

const StyledText = styled.svg`
  position: absolute;
  left: 15%;
  bottom: 40%;
  max-width: 70%;

  & > text {
    font: var(--t-brand-s);
  }
`;

const Bottom = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: absolute;
  top: 64%;
  bottom: 0;
  left: 10px;
  right: 10px;
  text-align: center;
`;

type Props = {
  progresses: number[];
  bottom?: ReactNode;
  text: string;
  colors?: { from: string; to?: string }[];
  size?: keyof typeof unitMapping;
  shadow?: string;
};

export const CircularProgressIndicator = ({
  bottom,
  progresses,
  text,
  colors,
  size,
  shadow,
}: Props) => {
  const { width: viewPortSize, height: viewPortHeight } = getTextSize(
    text,
    `bold 16px pressio`
  );
  return (
    <Vertical
      style={{
        position: 'relative',
        ...(shadow && {
          filter: `drop-shadow(0 0 12px ${shadow})`,
        }),
      }}
    >
      <HalfCircularProgressBar
        size={size}
        progresses={progresses}
        colors={colors}
      />
      <StyledText
        viewBox={`0 0 ${Math.max(viewPortSize, 32)} ${Math.max(viewPortHeight, 16)}`}
      >
        <text x="50%" y="100%" fill="white" textAnchor="middle">
          <tspan dy="-1">{text}</tspan>
        </text>
      </StyledText>
      <Bottom>{bottom}</Bottom>
    </Vertical>
  );
};
